export const userRole_candidate: string = "CANDIDATE";
export const userRole_globalAdmin: string = "GLOBAL_ADMINISTRATOR";
export const userRole_siteAdmin: string = "SITE_ADMINISTRATOR";
export const userRole_regionalAdmin: string = "REGIONAL_ADMINISTRATOR";
export const userRole_proctorLead: string = "PROCTOR";
export const userRole_proctor: string = "PROCTOR";
export const examTypeOptions: any = [
  {
    "examType": "UE",
    "name": "Undecided",
    "validForExamMaster": false,
    "validForCapacity": false
  },
  {
    "examType": "CE",
    "name": "Testing Center",
    "validForCapacity": true,
    "validForExamMaster": true
  },
  {
    "examType": "RE",
    "name": "Remote",
    "validForCapacity": false,
    "validForExamMaster": true
  },
  {
    "examType": "PE",
    "name": "Preliminary",
    "validForCapacity": true,
    "validForExamMaster": true
  },
  {
    "examType": "XE",
    "name": "Experience",
    "validForCapacity": true,
    "validForExamMaster": true
  }
];
export const examTypeOrder: any = examTypeOptions.map(o => o.examType);



// WEBPACK FOOTER //
// /opt/app-root/src/src/app/Common/appConstant.ts